import { render, staticRenderFns } from "./cr_gbubble.vue?vue&type=template&id=cd990b34&"
import script from "./cr_gbubble.vue?vue&type=script&lang=js&"
export * from "./cr_gbubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd990b34')) {
      api.createRecord('cd990b34', component.options)
    } else {
      api.reload('cd990b34', component.options)
    }
    module.hot.accept("./cr_gbubble.vue?vue&type=template&id=cd990b34&", function () {
      api.rerender('cd990b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/cr_gbubble.vue"
export default component.exports